import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import {MatInputModule} from '@angular/material/input';
import { SelectOptionComponent } from '../select-option/select-option.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'lib-sign-up',
  standalone: true,
  imports: [CommonModule,FormsModule,ReactiveFormsModule,MatInputModule, MatButtonModule,SelectOptionComponent],
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss'
})
export class SignUpComponent {
  public countries$: Observable<any[]> | undefined;
  signUpForm: FormGroup;
  submitted = false;
  private THREE_MILISECOND: number = 5000;
  
  countryData:any=['India','Pakistan','Kanada','America']
  regionData:any=['Kerla','Tamil Nadu','Karnataka','Andhra']
  constructor(
    private fb: FormBuilder,
  ) {
    this.signUpForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          // emailDomainValidator('electrolux.com'),
        ],
      ],
      countryId: ['', [Validators.required]],
      region: ['', [Validators.required]],
    });
  }

  // convenience getter for easy access to form fields
  get f(): { [key: string]: AbstractControl } {
    return this.signUpForm.controls;
  }

  ngOnInit() {
   
    
    // this.countries$ = this.service
    //   .getCountryList()
    //   .pipe(map((res) => res.countries));
  }
 

  public signUp() {
    // console.log(this.signUpForm.value.countryId);
    // console.log(this.signUpForm.value.region);
    this.submitted = true;

    // // stop here if form is invalid
    // if (this.signUpForm.invalid) {
    //   return;
    // }
    // this.authService
    //   .signUpApi(this.signUpForm.getRawValue())
    //   .subscribe((res) => {
    //     this.router.navigate([`/auth/login`]);
    //     this.snackbar.open('Account Created Sucessfully!', 'OK', {
    //       duration: this.THREE_MILISECOND,
    //     });
    //   });
  }
}
